import React, {useEffect, useRef, useState} from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import productCardIni from "../../../../cookieStorage/productCardIni";
import ProductBasketItem from "./productBasketItem";

function ProductBasket() {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const closeTimerRef = useRef(null);

    const handleEnter = () => {
        if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
        setOpen(true);
    };

    const handleLeave = () => {
        // ίδιο concept με το setTimeout(100) που είχες
        closeTimerRef.current = setTimeout(() => {
            setOpen(false);
        }, 100);
    };

    const goToCart = () => {
        setOpen(false);
        navigate("/shopingcard");
    };
    const shopingCardList=productCardIni();
    const totalPrice = shopingCardList.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );

    return (
        <div className="relative" onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
            <Link to="/shopingcard" className="relative">
                <i className="fas fa-shopping-cart text-gray-700 hover:text-brand-green cursor-pointer text-xl transition-colors duration-300"></i>

                {shopingCardList.length > 0 && (
                    <span className="absolute -top-2 -right-2 bg-custom-green text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
    {shopingCardList.length}
  </span>
                )}
            </Link>

            {/* Dropdown */}
            <div
                id="cart-dropdown"
                className={`cart-dropdown absolute right-0 top-12 w-80 bg-white shadow-xl rounded-lg border z-50 transition-opacity duration-150
          ${open ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}
                // extra ασφάλεια: αν μπεις στο dropdown, μην κλείσει από timer
                onMouseEnter={handleEnter}
                onMouseLeave={handleLeave}
            >
                <div className="p-4 border-b">
                    <h3 className="font-semibold text-gray-800">Shopping Cart ({shopingCardList.length} items)</h3>
                </div>

                <div className="p-4 space-y-4 max-h-80 overflow-y-auto">

                    {
                        shopingCardList?.map((item, index) => (
                            <ProductBasketItem key={item.productID}
                                               {...{name:item.name,
                                                   quantity:item.quantity,
                                                   image:item.image,
                                                   description: item.description,
                                                   price:item.price}}
                            />
                        ))
                    }
                </div>

                <div className="p-4 border-t">
                    <div className="flex justify-between items-center mb-3">
                        <span className="font-semibold text-gray-800">Total:</span>
                        <span className="font-bold text-lg text-brand-green">€{totalPrice}</span>
                    </div>

                    <button
                        onClick={goToCart}
                        className="w-full bg-custom-green text-white py-2 rounded-lg font-medium hover:bg-opacity-90"
                    >
                        View Cart
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ProductBasket;
